import React, { Suspense, useEffect, useRef } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.scss";
import "./shared-styling.scss";
import "react-quill-new/dist/quill.snow.css";
import "react-phone-number-input/style.css";

import { UserContextProvider } from "./context/user-context";
import { Spin, message } from "antd";
import { getMissingRequiredEnvVars } from "./util/config";
import { AuthProvider } from "./context/authContext";
import AppRoutes from "./routes/AppRoutes";
import GlobalErrorBoundary from "./components/GlobalErrorBoundary/GlobalErrorBoundary";

function App() {
  const configErrorShown = useRef(false);
  useEffect(() => {
    const missing = getMissingRequiredEnvVars();
    if (missing.length > 0 && !configErrorShown.current) {
      configErrorShown.current = true;
      message.error("Something went wrong. Contact support.", 8);
      console.error(
        "Missing required config:",
        missing.join(", "),
        "- Check environment configuration."
      );
    }
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <UserContextProvider>
          <AuthProvider>
            <GlobalErrorBoundary>
              <Suspense
                fallback={
                  <Spin
                    className="loader orange-theme-loader"
                    size="large"
                  />
                }
              >
                <AppRoutes />
              </Suspense>
            </GlobalErrorBoundary>
          </AuthProvider>
        </UserContextProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
